module.exports = __webpack_public_path__ + "media/images/icon-exit-orange-3fbf3dc4820618dbb185c4b2a93b9183.svg";